'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var InternalBadge_web_types = require('./InternalBadge.web.types.cjs');
var InternalBadge_web_styles = require('./InternalBadge.web.styles.cjs');

/**
 * Used to display status of an object.
 *
 * @scope Web, Internal
 */ const InternalBadge = ({ children, size = "medium", intention = "neutral", ...rest })=>{
    const theme = react.useTheme();
    const badgeStyles = [
        InternalBadge_web_styles.base,
        InternalBadge_web_styles.badgeSize(theme, size),
        InternalBadge_web_styles.badgeIntention(theme, intention)
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: badgeStyles,
        "data-testid": "aviary-badge",
        ...rest,
        children: size === InternalBadge_web_types.BADGE_SIZES.medium ? children : null
    });
};

exports.InternalBadge = InternalBadge;
//# sourceMappingURL=InternalBadge.web.cjs.map
